
import { MOCK_SITE_SAMPLE_IDS } from "./constants";

const default_settings = {
  backup_installed: true,
  ev: true,
  ev_control: true,
  hotwater: true,
  reserve: 20,
  control_mode: "default",
  dnsp: "ec82bdfc-13d5-485f-86db-df5f63248fbf",
  dnsp_name: "Citipower",
  vpp: null,
  retailer: "923d0a5f-e7ff-11ee-b5de-025e9f07eba1",
  vpp_requested: null,
  control_mode_notification: null,
  optimisation_status: "active",
  amber: null,
  tariff: 67,
  retailer_name: "AGL",
};

const amber_settings = {
  backup_installed: true,
  ev: false,
  ev_control: true,
  hotwater: false,
  reserve: 20,
  control_mode: "optimisation",
  dnsp: "ec82bdfc-13d5-485f-86db-df5f63248fbf",
  dnsp_name: "Citipower",
  vpp: null,
  retailer: "923d0a5f-e7ff-11ee-b5de-025e9f07eba1",
  vpp_requested: null,
  control_mode_notification: null,
  optimisation_status: "active",
  amber: 1736859600,
  tariff: null,
  retailer_name: "Amber",
};

const tou_settings = {
  backup_installed: true,
  ev: false,
  ev_control: true,
  hotwater: false,
  reserve: 20,
  control_mode: "optimisation",
  dnsp: "ec82bdfc-13d5-485f-86db-df5f63248fbf",
  dnsp_name: "Citipower",
  vpp: null,
  retailer: "923d0a5f-e7ff-11ee-b5de-025e9f07eba1",
  vpp_requested: null,
  control_mode_notification: null,
  optimisation_status: "active",
  amber: null,
  tariff: 67,
  retailer_name: "AGL",
};

export const getSettings = (site) => {
  switch (site) {
    case MOCK_SITE_SAMPLE_IDS.optimisation_amber:
      return amber_settings;
    case MOCK_SITE_SAMPLE_IDS.optimisation_tou:
      return tou_settings;
    case MOCK_SITE_SAMPLE_IDS.notification_backup:
      return amber_settings;
    default:
      return default_settings
  }
};

export const updateSettings = (body) => {
  return {
    ...amber_settings,
    ...body,
  };
};

export const getTariffList = () => {
  return [
    {
      tariff_type: "residential",
      created_at: 1722313870,
      optimisation_reset_time: "00:00:00",
      dnsp_default: true,
      dnsp: "ec82bdfc-13d5-485f-86db-df5f63248fbf",
      definition: {
        name: "CitiPower Tariff TOU for Conversion to JSON",
        prices: [
          {
            time_period: "Off_Peak",
            buy: 0.2441,
            sell: 0.049,
          },
          {
            time_period: "Peak",
            buy: 0.3719,
            sell: 0.049,
          },
        ],
        seasons: [
          {
            name: "Year Round",
            days_of_week: [
              {
                name: "All Days",
                days_of_week: [0, 1, 2, 3, 4, 5, 6],
                holidays: false,
                priority: 2,
                time_periods: [
                  {
                    name: "Off_Peak",
                    priority: 1,
                    time_ranges: [
                      {
                        end_hour: 15,
                        start_hour: 0,
                      },
                      {
                        end_hour: 24,
                        start_hour: 21,
                      },
                    ],
                  },
                  {
                    name: "Peak",
                    priority: 1,
                    time_ranges: [
                      {
                        end_hour: 21,
                        start_hour: 15,
                      },
                    ],
                  },
                ],
              },
            ],
            date_ranges: [
              {
                end_day: 31,
                start_month: 1,
                end_month: 12,
                start_day: 1,
              },
            ],
            priority: 0,
          },
        ],
      },
      source: "default_tou",
      name: "citipower_tou",
      id: 67,
    },
    {
      tariff_type: "residential",
      created_at: 1722313870,
      optimisation_reset_time: "00:00:00",
      dnsp_default: true,
      dnsp: "ec82bdfc-13d5-485f-86db-df5f63248fbf",
      definition: {
        name: "CitiPower Tariff Flat for Conversion to JSON",
        prices: [
          {
            time_period: "Flat",
            buy: 0.29,
            sell: 0.049,
          },
        ],
        seasons: [
          {
            name: "Year Round",
            days_of_week: [
              {
                name: "All Days",
                days_of_week: [0, 1, 2, 3, 4, 5, 6],
                holidays: false,
                priority: 2,
                time_periods: [
                  {
                    name: "Flat",
                    priority: 1,
                    time_ranges: [
                      {
                        end_hour: 24,
                        start_hour: 0,
                      },
                    ],
                  },
                ],
              },
            ],
            date_ranges: [
              {
                end_day: 31,
                start_month: 1,
                end_month: 12,
                start_day: 1,
              },
            ],
            priority: 0,
          },
        ],
      },
      source: "default_flat",
      name: "citipower_flat",
      id: 86,
    },
  ];
};
